import { render } from "./ProjectProcess.vue?vue&type=template&id=1648fd04&ts=true"
import script from "./ProjectProcess.vue?vue&type=script&lang=ts"
export * from "./ProjectProcess.vue?vue&type=script&lang=ts"

import "./ProjectProcess.vue?vue&type=style&index=0&id=1648fd04&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__